import { message as msgAntd } from 'antd';
import { AxiosError } from 'axios';
import { setToken } from 'src/app/utils/axios.instance';
/**
 * global error handler for axios
 * @param error
 * @param handleMessage
 * @param resetReducerStatesToDefault
 * @param removeCookie
 * @returns
 */

export const handleResponseErrors = (
  error: AxiosError<{ message: string }>,
  handleMessage: (textMessage: string) => void,
  resetReducerStatesToDefault: () => void,
  removeCookie: () => void,
): boolean => {
  if (error.config && error.config.blockErrorHandler) {
    return false;
  }

  /* 
  If error has 401 status code then inform user with 'Session Expired' message
  Then remove token and user from session storage
  */

  switch (error.response?.status) {
    case 401:
      handleMessage('Session Expired');
      setToken(undefined);
      // storageHelper.removeKeyPair("token");
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      removeCookie();
      resetReducerStatesToDefault();
      return true;
    default: {
      return true;
    }
  }
};

/**
 * gets error message from the errorList
 * @param messageKey
 * @param errorTexts
 */
export const displayErrorMessage = (
  // messageKey: languageTypes.ErrorTextsKeysType,
  errorTexts: string,
) => {
  msgAntd.error(errorTexts);
};
